import Dashboard from '@/components/Explorer/Dashboard.vue'
import ExplorerLogin from '@/components/Explorer/ExplorerLogin.vue'

export default [
    {
        path: '/',
        name: 'explorer_dashboard',
        component: Dashboard,
        meta: { requiresAuth: true }
    },
    {
        path: '/login',
        name: 'explorer_login',
        component: ExplorerLogin,
        meta: { requiresAuth: false }
    }
]
